


















































import {
  defineComponent,
  computed,
  onBeforeMount,
  ref,
} from '@vue/composition-api'
import { useTournament } from '../reactive/tournament.state'
import Banner from '../components/tournament/Banner.vue'
import NavBar from '../components/tournament/NavBar.vue'
import InvitationCard from '../components/tournament/InvitationCard.vue'

export default defineComponent({
  components: { Banner, NavBar, InvitationCard },
  setup(props, { root }) {
    const {
      isOpen,
      isAdmin,
      loadTournament,
      tournament,
      loadTournamentIsLoading,
    } = useTournament()

    const showInviationCard = ref(false)
    const copySnackbar = ref(false)

    onBeforeMount(() => loadTournament(root.$route.params.hash))

    const hasTournament = computed(() => !!tournament.name)
    const state = computed(() => tournament.state || '')
    const title = computed(() => tournament.name || root.$t('notFound.title'))
    const visitorId = computed(() => tournament.visitorId || '')
    const subtitle = computed(
      () => tournament.owner || root.$t('notFound.subtitle'),
    )
    const shareUrl = computed(
      () => `${location.origin}/tournament/${tournament.visitorId}`,
    )

    function clipboardSuccessHandler() {
      showInviationCard.value = false
      copySnackbar.value = true
    }

    return {
      title,
      subtitle,
      state,
      visitorId,
      isOpen,
      isAdmin,
      hasTournament,
      loadTournamentIsLoading,
      showInviationCard,
      shareUrl,
      clipboardSuccessHandler,
      copySnackbar,
    }
  },
})
